import axios from 'axios';
import {errorHandler} from '../libs/errorhandler';

export default {
    setup(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post('alloction-prepaid/set-up', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    saveSchedule(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post('alloction-prepaid/save-schedule', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}